<template>
  <d-row>
    <!-- Editor -->
    <d-col lg="9" class="mb-4">
      <d-card class="card-small">

        <!-- Form Example -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">Criar um chamado</h6>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <ticket-form :model.sync="model"/>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>

    <!-- Sidebar Widgets -->
    <d-col lg="3" md="12">
      <sidebar-actions :model.sync="model" />
    </d-col>
  </d-row>
</template>

<script>
import SidebarActions from './SidebarActions.vue';
import TicketForm from './TicketForm.vue';
import { MODEL } from './TicketModel';

export default {
  name: 'ticket-page',
  components: {
    TicketForm,
    SidebarActions,
  },
  data() {
    return {
      model: { ...MODEL },
    };
  },
  methods: {},
};
</script>
